import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { SIGNUP_PATH } from '~/config';

export const useSignUpRedirect = () => {
  const router = useRouter();
  const SIGNUP_QUERY = 'signup_type=BPD-RECRUIT';

  const signUpRedirect = useCallback(() => {
    router.push(`${SIGNUP_PATH}?${SIGNUP_QUERY}`);
  }, [router]);

  return { signUpRedirect };
};
